module.exports = __webpack_public_path__ + "img/major3.2aa5d6a2.png";